import { createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }) => ({
  inputsGroup: {
    display: 'flex',
    gap: unit
  },
  btnLink: {
    padding: [12, 6]
  }
});

export default createUseStyles(styles);
